/** 購入フロー ステップ間の状態(カート・会社ID・注文ID)を localStorage で保持 (P2) */
import type { PaymentMethod } from '../api/purchaseApi';

export interface CartLine {
  checked: boolean;
  userCount: number;
  paymentMethod: PaymentMethod; // GBなび以外は 'lump' 固定
}
export interface PurchaseState {
  cart: Record<string, CartLine>;
  /** 契約者情報フォームの入力内容(戻る操作で復元する) */
  account?: Record<string, string>;
  billingCompanyId?: string;
  orderId?: string;
}

const KEY = 'gbpav_purchase';

export function loadState(): PurchaseState {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return JSON.parse(raw) as PurchaseState;
  } catch { /* noop */ }
  return { cart: {} };
}

export function saveState(s: PurchaseState): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(s));
  } catch { /* noop */ }
}

export function clearState(): void {
  try {
    localStorage.removeItem(KEY);
  } catch { /* noop */ }
}
